import { BoldIcon as e, ItalicIcon as t, UnderlineIcon as n } from "lucide-react";
import { jsx as r } from "react/jsx-runtime";
//#region lib/Leafs/index.tsx
var i = () => ({
	class: "leaf",
	name: "core/bold",
	actions: [{
		name: "toggle-bold",
		tool: () => /* @__PURE__ */ r(e, { style: {
			width: "0.8em",
			height: "0.8em"
		} }),
		hotkey: "mod+b",
		handler: () => !0
	}],
	getStyle: () => "font-bold"
}), a = () => ({
	class: "leaf",
	name: "core/italic",
	actions: [{
		name: "toggle-italic",
		tool: () => /* @__PURE__ */ r(t, { style: {
			width: "0.8em",
			height: "0.8em"
		} }),
		hotkey: "mod+i",
		handler: () => !0
	}],
	getStyle: () => "italic"
}), o = () => ({
	class: "leaf",
	name: "core/underline",
	actions: [{
		name: "toggle-underline",
		hotkey: "mod+u",
		tool: () => /* @__PURE__ */ r(n, { style: {
			width: "0.8em",
			height: "0.8em"
		} }),
		handler: () => !0
	}],
	getStyle: () => "underline"
});
//#endregion
export { i as Bold, a as Italic, o as Underline };
